import React from 'react';
import { FooterContainer, Logo, LogoWrapper } from './styles';

import LOGO from 'assests/images/logo.png';


const Footer: React.FC = () => (
    <FooterContainer>
        <LogoWrapper>
            <Logo src={LOGO} alt="Ailabs" />
        </LogoWrapper>
        <small>&copy; {new Date().getFullYear()} Ailabs. All rights reserved.</small>
    </FooterContainer>
);

export default Footer;